import React from "react";
import { useTranslation } from "react-i18next";
import { OutputBody, OutputBox, OutputButton, OutputHeader, OutputColor } from "./OutputBox";
import ScrollBox from "./ScrollBox";
var EditorOutput = function EditorOutput(_a) {
  var onClose = _a.onClose,
    outputHeight = _a.outputHeight,
    problems = _a.problems;
  var t = useTranslation()[0];
  var scrollBoxRef = React.createRef();
  return React.createElement(OutputBox, null, React.createElement(OutputHeader, {
    title: t("problemsTitle"),
    color: OutputColor.Gray
  }, React.createElement(OutputButton, {
    label: t("button.close"),
    onClick: onClose,
    dataCy: "close-btn"
  })), React.createElement(OutputBody, null, React.createElement(ScrollBox, {
    maxHeight: outputHeight,
    ref: scrollBoxRef
  }, t("incompatibleExerciseTemplate"), " ", t("pleaseReportFollowingErrorsToCourseInstructor"), ":", problems.map(function (x, i) {
    return React.createElement("div", {
      key: i
    }, x);
  }))));
};
export default EditorOutput;